import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Form, Input, InputPassword, Title, Button, Text } from 'ui';
import { login } from 'api';
import logo from '../assets/logo-white.png'

export default function Login(props) {

  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [value, setValue] = useState({});
  const [error, setError] = useState("");


  async function submit() {
    if(loading) {
      return;
    }
    setError("");
    if(!value.email) {
      setError("Please enter your email address.");
      return;
    }
    if(!value.password) {
      setError("Please enter you password.");
      return;
    }
    try {
      setLoading(true);
      await login(value.email, value.password);
    }
    catch(error) {
      console.log(error);
      setLoading(false);
      if(error.code === 'auth/too-many-requests') {
        setError("Too many failed login requests. Please try again later.");
      }
      if(error.code === 'auth/wrong-password') {
        setError("Your password was incorrect. Please try again.");
      }
      if(error.code === 'auth/invalid-email' || error.code === 'auth/user-not-found') {
        setError("User not found. Please check your email address and try again.");
      }
      else {
        setError(error.message);
      }
      return;
    }

    setLoading(false);
    history.push("/");
  }

  return (
    <div className="auth auth-login">
      <Form onSubmit={submit} value={value} onChange={setValue} className="auth-sidebar">
        <div className="auth-logo">
          <img src={logo} alt="Taptivate"/>
        </div>
        <Title white className="auth-title">Login</Title>
        {error && <Text block color="red" bold small style={{paddingBottom:16}}>{error}</Text>}
        <Input name="email" label="Email Address" white className="auth-input"/>
        <InputPassword name="password" label="Password" white className="auth-input"/>
        <Button block small tertiary white className="auth-link" label="Forgot your password?" to="send-password-reset"/>
        <Button block small tertiary white className="auth-link" label="Not a member? Register here." to="register"/>
        <Button className="auth-button" white label={loading ? "Loading..." : "Login"} onClick={submit}/>
        <div style={{paddingTop:40}}>
          <Text block size={30} bold white>Taptivate communicates your brand's digital experience at the Unboxing Moment.</Text>
          <Text block size={30} bold orange>Activate Today.</Text>
        </div>
      </Form>
    </div>
  );
}